import React, { useEffect, useCallback, useMemo, useState } from 'react';
import { useRedirect } from 'react-admin';
import WizardStepper from '../../core/components/wizardStepper/WizardStepper';
import { CreationFundInvestorTagContext } from './creationSteps/CreationFundInvestorTagContext';
import {
  GenerateMessageOnLeave,
  listOfSteps,
  STEP
} from './creationSteps/utils';
import { isEmpty } from 'lodash';
import FormTitleBar from '../../core/components/FormTitleBar';
import { getInitials } from '../../core/utils';

const FundInvestorTagCreate = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [fundInvestorTagContext, setFundInvestorTagContext] = useState({});
  const providerFormContext = useMemo(
    () => ({ fundInvestorTagContext, setFundInvestorTagContext }),
    [fundInvestorTagContext, setFundInvestorTagContext]
  );
  const [isNextAvailable, setIsNextAvailable] = useState(false);
  const redirect = useRedirect();
  const [shouldHideBackButton, setShouldHideBackButton] = useState(false);
  const [isSpinnerOnNextButton, setIsSpinnerOnNextButton] = useState(false);
  const [isSaveAndCloseStep, setIsSaveAndCloseStep] = useState(false);

  const isLastStep = useCallback(() => {
    return !!(!isEmpty(listOfSteps) && listOfSteps.length === activeStep + 1);
  }, [activeStep]);

  const isItSaveAndCloseStep = useCallback(() => {
    if (!isEmpty(listOfSteps)) {
      return !!(
        listOfSteps[activeStep].name === STEP.assignTag && !isLastStep()
      );
    }
  }, [activeStep, isLastStep]);

  useEffect(() => {
    isItSaveAndCloseStep()
      ? setIsSaveAndCloseStep(true)
      : setIsSaveAndCloseStep(false);
  }, [isItSaveAndCloseStep]);

  const getActiveStep = () => {
    const step = listOfSteps[activeStep];
    return (
      <step.component
        variant="standard"
        onSubmitEnd={onSubmitEnd}
        setIsNextAvailable={setIsNextAvailable}
        setShouldHideBackButton={setShouldHideBackButton}
        setFundInvestorTagContext={setFundInvestorTagContext}
        fundInvestorTagContext={fundInvestorTagContext}
        setIsSpinnerOnNextButton={setIsSpinnerOnNextButton}
      />
    );
  };

  const onSubmitEnd = () => {
    if (listOfSteps[activeStep].name === STEP.tagDetails) {
      setActiveStep(activeStep + 1);
    }
    if (listOfSteps[activeStep].name === STEP.assignTag) {
      handleClose();
    }
  };

  const handleClose = () => {
    if (fundInvestorTagContext.id === undefined) {
      redirect('list', '/fundinvestortags');
    } else {
      redirect(`/fundinvestortags/${fundInvestorTagContext.id}`);
    }
  };

  const handleNextForm = () => {
    if (listOfSteps[activeStep].name === STEP.tagDetails) {
      document
        .getElementById('formTagDetails')
        .dispatchEvent(new Event('submit', { cancelable: true }));
    }
    if (listOfSteps[activeStep].name === STEP.assignTag) {
      document
        .getElementById('formTagRelationship')
        .dispatchEvent(new Event('submit', { cancelable: true }));
    }
  };

  const displayCreatedInfo = () => {
    return (
      <FormTitleBar
        name={fundInvestorTagContext.name}
        showAvatar={true}
        avatarContent={getInitials(fundInvestorTagContext.name)}
      />
    );
  };

  return (
    <WizardStepper
      handleClose={handleClose}
      getActiveStep={getActiveStep}
      handleNextForm={handleNextForm}
      resource="Fund-Investor Tag"
      activeListOfSteps={listOfSteps}
      activeStep={activeStep}
      providerFormContext={providerFormContext}
      customContext={CreationFundInvestorTagContext}
      generateMessageOnLeave={
        <GenerateMessageOnLeave name={fundInvestorTagContext?.name} />
      }
      resourceCreated={fundInvestorTagContext}
      shouldDisplayResourceCreatedInfo={true}
      displayResourceCreatedInfo={displayCreatedInfo}
      isFirstStepPristine={true}
      isNextAvailable={isNextAvailable}
      shouldHideBackButton={shouldHideBackButton}
      isSpinnerOnNextButton={isSpinnerOnNextButton}
      isSaveAndCloseStep={isSaveAndCloseStep}
    />
  );
};
export default FundInvestorTagCreate;
